/**
 * App 内他人主页深链，与原生约定 path：user/home?be_user_id
 */
import { ANDROID_QIPAO_PACKAGE } from './activityWebviewAppLink';

export { ANDROID_QIPAO_PACKAGE };

export const USER_HOME_PATH = 'user/home';

/**
 * @param {object} p
 * @param {string} p.beUserId
 * @returns {string} application/x-www-form-urlencoded 查询串
 */
export function buildUserHomeQueryString(p) {
  const q = new URLSearchParams();
  q.set('be_user_id', String(p.beUserId || '').trim());
  return q.toString();
}

/**
 * 用于 iframe / iOS：`qipao://user/home?be_user_id=...`
 * @param {object} p
 * @param {string} p.beUserId
 * @returns {string}
 */
export function buildQipaoUserHomeScheme(p) {
  return `qipao://${USER_HOME_PATH}?${buildUserHomeQueryString(p)}`;
}

/**
 * Android：`intent://user/home?be_user_id=...#Intent;...`
 * @param {object} p
 * @param {string} p.beUserId
 * @param {string} pkg
 * @param {string} fallbackUrl
 * @returns {string}
 */
export function buildAndroidIntentUserHome(p, pkg, fallbackUrl) {
  const qs = buildUserHomeQueryString(p);
  const beUserId = String(p.beUserId || '').trim();
  return `intent://${USER_HOME_PATH}?${qs}#Intent;scheme=qipao;package=${pkg};S.be_user_id=${encodeURIComponent(
    beUserId
  )};S.browser_fallback_url=${encodeURIComponent(fallbackUrl)};end`;
}

/**
 * 微信 `wx-open-launch-app` 的 extinfo（OpenSDK messageExt）
 * @param {object} p
 * @param {string} p.beUserId
 * @returns {string}
 */
export function buildWxUserHomeExtinfo(p) {
  const beUserId = String(p.beUserId || '').trim();
  if (!beUserId) return '';
  return JSON.stringify({
    path: USER_HOME_PATH,
    be_user_id: beUserId,
  });
}
